import { render, staticRenderFns } from "./ywzx_detail.vue?vue&type=template&id=010f772a&"
import script from "./ywzx_detail.vue?vue&type=script&lang=js&"
export * from "./ywzx_detail.vue?vue&type=script&lang=js&"
import style0 from "./ywzx_detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports